<div class="estab-select">
  <select
    #sel
    [value]="selectedId || ''"
    (change)="onNativeChange(sel.value)"
    [attr.aria-label]="'components.establishmentSwitcher.ariaLabel' | translate"
  >
    <option value="" disabled>{{ 'components.establishmentSwitcher.placeholder' | translate }}</option>
    <option *ngFor="let e of sortedEstablishments; trackBy: trackById" [value]="e.id">
      {{ e.name }}
    </option>
  </select>

  <!-- chevron décoratif -->
  <span class="chev" aria-hidden="true">
    <svg viewBox="0 0 20 20" width="16" height="16">
      <path d="M5 7l5 6 5-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </span>
</div>
